import { z } from 'zod';

export const limitTypeSchema = z.object({
  id: z.coerce.number(),
  name: z.string(),
  lowValue: z.coerce.number().nullable(),
  highValue: z.coerce.number().nullable(),
  isActive: z.boolean(),
  updatedAt: z.coerce.date(),
});

export const limitTypeListSchema = z.array(limitTypeSchema);

export type LimitType = z.infer<typeof limitTypeSchema>;

const valueField = z
  .string()
  .trim()
  .refine((value) => value === '' || !Number.isNaN(Number(value)), 'Must be a number')
  .refine((value) => value === '' || Number(value) >= 0, 'Cannot be negative')
  .refine((value) => value === '' || /^\d+(\.\d{1,2})?$/.test(value), 'At most two decimal places');

export const limitTypeFormSchema = z
  .object({
    lowValue: valueField,
    highValue: valueField,
  })
  .refine(
    ({ lowValue, highValue }) =>
      lowValue === '' || highValue === '' || Number(lowValue) <= Number(highValue),
    { path: ['lowValue'], message: 'Low value cannot be greater than high value' },
  );

export type LimitTypeFormValues = z.infer<typeof limitTypeFormSchema>;

export interface UpdateLimitTypePayload {
  lowValue?: number;
  highValue?: number;
}
